import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LocalStorageData')
export class LocalStorageData {
  public static create(timestamp: number, data: string): LocalStorageData {
    return Object.assign(new LocalStorageData(), { timestamp, data });
  }
  @JsonProperty('timestamp', Number)
  // @ts-expect-error TS2322 - strict migration
  public timestamp: number = undefined;
  @JsonProperty('data', String)
  // @ts-expect-error TS2322 - strict migration
  public data: string = undefined;
}
